import moment from 'moment';

/**
 * Checks if the given Unix timestamp corresponds to today's date.
 *
 * This function is used to determine whether to save streaks.
 * The `timestamp` parameter should be a Unix timestamp (seconds since epoch).
 *
 * @param timestamp - The Unix timestamp to compare (in seconds).
 * @returns `true` if the timestamp corresponds to today, otherwise `false`.
 */
export const isToday = (timestamp: number): boolean => {
  const TODAY = moment().local();
  return moment.unix(timestamp).local().isSame(TODAY, 'day');
};

/**
 * Checks if the given Unix timestamp corresponds to yesterday's date.
 *
 * This function is used to determine whether the user has broken the streak.
 * The `timestamp` parameter should be a Unix timestamp (seconds since epoch).
 *
 * @param timestamp - The Unix timestamp to compare (in seconds).
 * @returns `true` if the timestamp corresponds to yesterday, otherwise `false`.
 */
export const isYesterday = (timestamp: number): boolean => {
  const YESTERDAY = moment().local().subtract(1, 'day');
  return moment.unix(timestamp).local().isSame(YESTERDAY, 'day');
};

// Note: This function uses Monday as the first day of the week.
export const getCurrentWeekNumber = (): number => {
  const now = new Date();
  const date = new Date(
    Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()),
  );

  const dayOfWeek = date.getUTCDay() || 7;

  date.setUTCDate(date.getUTCDate() + 4 - dayOfWeek);

  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));

  const weekNo = Math.ceil(
    ((date.getTime() - yearStart.getTime()) / 86400000 + 1) / 7,
  );

  return weekNo;
};

export const getCurrentDayIndex = (): number => {
  const today = new Date().getDay();
  return today === 0 ? 6 : today - 1;
};
